import { HttpContextToken } from '@angular/common/http';

/** Skip the bearer token on login / forgot-password requests. */
export const SKIP_AUTH = new HttpContextToken<boolean>(() => false);
